// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file login_maintenance_criteria.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file login_maintenance_criteria.proto.
 */
export const file_login_maintenance_criteria: GenFile = /*@__PURE__*/
  fileDesc("CiBsb2dpbl9tYWludGVuYW5jZV9jcml0ZXJpYS5wcm90bxIGZG9tYWluItoBChhMb2dpbk1haW50ZW5hbmNlQ3JpdGVyaWESEAoIbm9fbG9naW4YASABKAgSRAogbGVha2VkX3Bhc3N3b3Jkc19taW5fY2hhbmdlX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiEKGWxvZ2luX3N1bW1hcnlfbWluX3ZlcnNpb24YAyABKAUSQwofcGFzc3dvcmRfcG9saWN5X21pbl9jaGFuZ2VfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAqfAofTG9naW5NYWludGVuYW5jZUNyaXRlcmlhVmVyc2lvbhIuCipMT0dJTl9NQUlOVEVOQU5DRV9DUklURVJJQV9WRVJTSU9OX1VOS05PV04QABIpCiVMT0dJTl9NQUlOVEVOQU5DRV9DUklURVJJQV9WRVJTSU9OX1YzEANCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message domain.LoginMaintenanceCriteria
 */
export type LoginMaintenanceCriteria = Message<"domain.LoginMaintenanceCriteria"> & {
  /**
   * @generated from field: bool no_login = 1;
   */
  noLogin: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp leaked_passwords_min_change_time = 2;
   */
  leakedPasswordsMinChangeTime?: Timestamp | undefined;

  /**
   * @generated from field: int32 login_summary_min_version = 3;
   */
  loginSummaryMinVersion: number;

  /**
   * @generated from field: google.protobuf.Timestamp password_policy_min_change_time = 4;
   */
  passwordPolicyMinChangeTime?: Timestamp | undefined;
};

/**
 * Describes the message domain.LoginMaintenanceCriteria.
 * Use `create(LoginMaintenanceCriteriaSchema)` to create a new message.
 */
export const LoginMaintenanceCriteriaSchema: GenMessage<LoginMaintenanceCriteria> = /*@__PURE__*/
  messageDesc(file_login_maintenance_criteria, 0);

/**
 * Increase this version whenever a new field is added to LoginMaintenanceCriteria. The new version
 * allows new clients to discard their persisted LoginMaintenanceCriteria, which will be missing the
 * new field. 
 *
 * Take as an example adding `fooMinChangeTime` to LoginMaintenanceCriteria, with a maintenance job
 * that is based on a `fooChangeTime` in the login.
 *
 * - Client A is on the old version, Client B is on the new version
 * - Client B makes a new commit and includes `fooMinChangeTime` in LoginMaintenanceCriteria
 * - Client A gets that commit and applies it, but doesn't know about the `fooMinChangeTime` field
 *   in the proto struct, and thus ignores it. The vault gets persisted with
 *   LoginMaintenanceCriteria missing `fooMinChangeTime`
 * - At some point in the future Client A gets updated. It sees a vault with
 *   LoginMaintenanceCriteria but no `fooMinChangeTime`, so it runs the foo check maintenance job
 *     - While running the job the client sees that all logins in the vault already were checked for
 *       foo with the current `fooChangeTime`, so the maintenance job will get into an unexpected
 *       state
 *
 * @generated from enum domain.LoginMaintenanceCriteriaVersion
 */
export enum LoginMaintenanceCriteriaVersion {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: LOGIN_MAINTENANCE_CRITERIA_VERSION_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * LOGIN_MAINTENANCE_CRITERIA_VERSION_V1 = 1;
   * LOGIN_MAINTENANCE_CRITERIA_VERSION_V2 = 2;
   *
   * @generated from enum value: LOGIN_MAINTENANCE_CRITERIA_VERSION_V3 = 3;
   */
  V3 = 3,
}

/**
 * Describes the enum domain.LoginMaintenanceCriteriaVersion.
 */
export const LoginMaintenanceCriteriaVersionSchema: GenEnum<LoginMaintenanceCriteriaVersion> = /*@__PURE__*/
  enumDesc(file_login_maintenance_criteria, 0);

